enum ChartSeriesType {
  Area = "Area",
  Bar = "Bar",
  Line = "Line",
  Point = "Point",
}

export default ChartSeriesType;
